import { render, staticRenderFns } from "./BeefBasicSettingsList.vue?vue&type=template&id=4b73bcd9&scoped=true"
import script from "./BeefBasicSettingsList.vue?vue&type=script&lang=js"
export * from "./BeefBasicSettingsList.vue?vue&type=script&lang=js"
import style0 from "./BeefBasicSettingsList.vue?vue&type=style&index=0&id=4b73bcd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b73bcd9",
  null
  
)

export default component.exports